import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderTypeBilling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.6735 12.983H10.6252V13.3497C10.6252 13.6947 10.3452 13.9747 10.0002 13.9747C9.65516 13.9747 9.37516 13.6947 9.37516 13.3497V12.983H8.486C8.141 12.983 7.861 12.703 7.861 12.358C7.861 12.013 8.141 11.733 8.486 11.733H10.6735C10.9785 11.733 11.2268 11.4863 11.2268 11.183C11.2268 10.8797 10.9785 10.633 10.6735 10.633H9.32766C8.33266 10.633 7.52433 9.82134 7.52433 8.82468C7.52433 7.83134 8.33266 7.02467 9.32766 7.02467H9.37516V6.65801C9.37516 6.31301 9.65516 6.03301 10.0002 6.03301C10.3452 6.03301 10.6252 6.31301 10.6252 6.65801V7.02467H11.5152C11.8602 7.02467 12.1402 7.30468 12.1402 7.64967C12.1402 7.99468 11.8602 8.27467 11.5152 8.27467H9.32766C9.02266 8.27467 8.77433 8.52134 8.77433 8.82468C8.77433 9.13217 9.02266 9.38301 9.32766 9.38301H10.6735C11.6677 9.38301 12.4768 10.1897 12.4768 11.183C12.4768 12.1755 11.6677 12.983 10.6735 12.983ZM10.0002 2.08301C5.63516 2.08301 2.0835 5.63467 2.0835 9.99967C2.0835 14.3647 5.63516 17.9163 10.0002 17.9163C14.3652 17.9163 17.9168 14.3647 17.9168 9.99967C17.9168 5.63467 14.3652 2.08301 10.0002 2.08301Z",
		fill: "currentColor"
	})
});
export default SvgOrderTypeBilling;
